// import constants from '../../common/lib/utils/constants.js';

function getSendHandlerData(obj) {
	const validTypeA = Boolean(obj && obj.sendHandlerData);
	const validTypeB = Boolean(obj && obj.sendHandlerData && obj.sendHandlerData.handler);
	const validTypeFastbanktransfer = Boolean(
		obj && obj.sendHandlerData && obj.sendHandlerData.externalUrl && obj.sendHandlerData.externalParameters
	);
	if (!(validTypeA || validTypeB || validTypeFastbanktransfer)) {
		return null;
	}
	if (validTypeFastbanktransfer) {
		return obj.sendHandlerData;
	}
	// if the obj.sendHandlerData.actualSendHandler if defined
	// (in this case 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL')
	// then take the entire sendHandlerData
	// otherwise take the handler-object inside sendHandlerData
	const shallowDefinedActualType = obj.sendHandlerData && obj.sendHandlerData.actualSendHandler;
	const nestedObj = shallowDefinedActualType ? obj.sendHandlerData : obj.sendHandlerData.handler;
	// then inside this parsed object:
	// if the nested object has a sendHandlerData then use it
	// otherwise take the one obove
	const prioNested = nestedObj?.sendHandlerData?.handler ?? nestedObj?.sendHandlerData ?? nestedObj;
	return prioNested || obj.sendHandlerData;
}

function matchResponseFilter(payload, sendHandlerType) {
	try {
		const sendHandlerData = getSendHandlerData(payload);
		let actualSendHandler;
		const externalUrl = (sendHandlerData && sendHandlerData.externalUrl) || null;
		const externalParameters = (sendHandlerData && sendHandlerData.externalParameters) || null;

		const externalMethod = externalParameters && externalParameters.method ? externalParameters.method : 'post';
		const { accHistRef, paymentFetchResultFlow } = payload || {};
		const form = (sendHandlerData && sendHandlerData.form) || null;
		if (sendHandlerType === 'SEND_HANDLER_CONTROLLER') {
			// Creditcard, Skrill, MasterCard
			// filter response to detect next sendhandlertype
			// two types of response-objects can be handled.
			// ---
			// the type 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL' is used for creditCard
			// and only specified in the execute-deposit-response object, in difference to
			// other types that are specified in the getDepositPaymentMethods-response
			// --
			// sendHandlerData = getSendHandlerData(payload);
			actualSendHandler =
				sendHandlerData?.actualSendHandler ??
				payload.sendHandlerData?.handler?.actualSendHandler ??
				payload.sendHandlerData?.actualSendHandler;
		} else if (
			sendHandlerType === 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL' &&
			payload.sendHandlerData &&
			payload.sendHandlerData.actualSendHandler === 'EXTERNAL_WINDOW'
		) {
			actualSendHandler = payload.sendHandlerData.actualSendHandler;
		} else if (
			(sendHandlerType === 'EXTERNAL_WINDOW' || sendHandlerType === 'NATIVE_APP') &&
			payload.sendHandlerData &&
			(payload.sendHandlerData?.handler?.actualSendHandler === 'RESULT_AFTER_SINGLE_CALL' ||
				payload.sendHandlerData?.handler?.actualSendHandler === 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL')
		) {
			actualSendHandler = payload.sendHandlerData.handler.actualSendHandler;
		} else {
			actualSendHandler = sendHandlerType;
		}
		return {
			accHistRef,
			actualSendHandler,
			externalUrl,
			externalParameters,
			externalMethod,
			paymentFetchResultFlow,
			sendHandlerData,
			form
		};
	} catch (e) {
		// eslint-disable-next-line
		console.error('error while executing matchResponseFilter', e);
	}
	return {};
}

// exports for tests within curly braces
export { getSendHandlerData };
export default matchResponseFilter;
